import React from 'react';
import { Check, X } from 'lucide-react';

const RULES = [
  { id: 'length', label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { id: 'upper', label: 'One uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { id: 'lower', label: 'One lowercase letter', test: (p) => /[a-z]/.test(p) },
  { id: 'number', label: 'One number', test: (p) => /\d/.test(p) },
];

export function getPasswordStrength(password) {
  if (!password) return 0;
  const passed = RULES.filter(r => r.test(password)).length;
  return passed;
}

export default function PasswordStrength({ password }) {
  if (!password) return null;

  const passed = RULES.filter(r => r.test(password)).length;
  const total = RULES.length;
  const percent = (passed / total) * 100;

  let color = '#ef4444'; // red
  let label = 'Weak';
  if (passed >= 4) { color = '#10b981'; label = 'Strong'; }
  else if (passed >= 3) { color = '#f59e0b'; label = 'Fair'; }
  else if (passed >= 2) { color = '#f97316'; label = 'Weak'; }

  return (
    <div className="password-strength">
      {/* Strength bar */}
      <div className="password-strength-bar">
        <div
          className="password-strength-fill"
          style={{ width: `${percent}%`, background: color }}
        />
      </div>
      <div className="password-strength-label" style={{ color }}>
        {label}
      </div>

      {/* Requirements checklist */}
      <ul className="password-strength-rules">
        {RULES.map(rule => {
          const met = rule.test(password);
          return (
            <li key={rule.id} className={met ? 'met' : ''}>
              {met ? <Check size={12} /> : <X size={12} />}
              <span>{rule.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
